import { photos } from '../assets/photos'

const SHOTS = [
	{ src: photos.moten, label: 'Möt experter och utställare' },
	{ src: photos.besokare, label: 'Få inspiration och nya perspektiv' },
	{ src: photos.meditation, label: 'Delta i föredrag och workshops' },
	{ src: photos.scenen, label: 'Träffa likasinnade och bli en del av gemenskapen' },
]

const ExperienceRow = () => (
	<section className='hx-section'>
		<div className='hx-wrap'>
			<div className='hx-lede'>
				<h2>Mer än en mässa, en upplevelse</h2>
				<p>
					På Harmoni Expo möts människor, idéer och möjligheter. Här kan du utforska, prova, lyssna,
					handla och fylla på med ny energi.
				</p>
			</div>
			<ul className='hx-shots'>
				{SHOTS.map((shot) => (
					<li key={shot.label} className='hx-shot'>
						{shot.src && <img src={shot.src} alt={shot.label} loading='lazy' />}
						<span className='hx-shot__label'>{shot.label}</span>
					</li>
				))}
			</ul>
		</div>
	</section>
)

export default ExperienceRow
